<template>
  <div class="p-5">
    <h2 class="ml-3">Etiquetas</h2>
    <v-row> 
      <v-form v-model="formValid" ref="myForm" class="align-items-center d-flex w-100 px-3 pt-3 pb-5 mb-3">
        <div style="width: 25%;" >
          <v-text-field
            class="input is-rounded px-3"
            type="text"
            v-model="codOdt"
            :rules="[rules.required]"
            label="Código ODT / Albarán"
          />
          <v-text-field
            class="input is-rounded px-3"
            type="text"
            v-model="fila"
            :rules="[rules.required]"
            label="Fila"
          />
          <v-text-field
            class="input is-rounded px-3"
            type="text"
            v-model="columna"
            :rules="[rules.required]"
            label="Columna"
          />
          <v-text-field
            class="input is-rounded px-3"
            type="text"
            v-model="numEtiquetas"
            :rules="[rules.required]"
            label="Número de etiquetas"
          />
        </div>
        <div style="width: 75%;" class="ml-5">
          <v-radio-group
            row
            v-model="tipo"
            @change="modeloTarifarioActual = ''; modeloTarifarioPremium = ''; evento = ''; eventoPremium = ''"
            column
            label = "Precios"
          >
            <v-radio
              label="Actuales"
              value="1"
            ></v-radio>
            <v-radio
              label="Futuros"
              value="2"
            ></v-radio>
          </v-radio-group>
          <div class="d-flex flex-wrap">
            <div style="width: 48%">
              <v-autocomplete
                :items="modelosTarifa"
                density="compact"
                label="Selecciona el Modelo Tarifario Premium"
                item-text="descripcion"
                item-value="id"
                v-model="modeloTarifarioPremium"
                @change="getEventosPremium()"
                required
              >
                <template v-slot:no-data>
                  <div class="px-4">No hay modelos</div>
                </template>
              </v-autocomplete>
            </div>
            <div style="width: 48%" class="ml-3">
              <v-autocomplete
                v-if="tipo == '2' && modeloTarifarioPremium !== ''"
                :items="eventosPremium"
                density="compact"
                label="Selecciona el Evento premium"
                item-text="referencia"
                item-value="id"
                v-model="eventoPremium"
                :loading="cargandoEventosPremium"
                :required="tipo == '2'"
              >
                <template v-slot:no-data>
                  <div class="px-4">No hay eventos</div>
                </template>
              </v-autocomplete>
            </div>
            <div style="width: 48%">
              <v-autocomplete
                v-if="tipo == '2'"
                :items="modelosTarifa"
                density="compact"
                label="Selecciona el Modelo Tarifario a Futuro"
                item-text="descripcion"
                item-value="id"
                v-model="modeloTarifarioActual"
                @change="getEventos()"
                :required="tipo == '2'"
              >
                <template v-slot:no-data>
                  <div class="px-4">No hay modelos</div>
                </template>
              </v-autocomplete>
            </div>
            <div style="width: 48%" class="ml-3">
              <v-autocomplete
                v-if="tipo == '2' && modeloTarifarioActual !== ''"
                :items="eventos"
                density="compact"
                label="Selecciona el Evento a Futuro"
                item-text="referencia"
                item-value="id"
                v-model="evento"
                :loading="cargandoEventos"
                :required="tipo == '2'"
              >
                <template v-slot:no-data>
                  <div class="px-4">No hay eventos</div>
                </template>
              </v-autocomplete>
            </div>
          </div>
        </div>
      
        <v-btn large dark fab absolute bottom right class="orange guardar" @click='enviar()'>
          <!-- {{ $t('lang.comun.guardar') }}-->
          <v-icon>check</v-icon>
        </v-btn>
      </v-form>
    </v-row>
  </div>
</template>
<script>
import { RegistroApiService } from '@/api/RegistroApiService'
import { InformesApiService } from '@/api/InformesApiService'
import { TwisterRestApiService } from '@/api/TwisterRestApiService'

const registroApiService = new RegistroApiService()
const informesApiService = new InformesApiService()
const twisterRestApiService = new TwisterRestApiService()
export default {
  data() {
    return {
      formValid: false,   
      fila: 1,
      columna: 1,
      numEtiquetas: 1,
      codOdt: sessionStorage.getItem('codOdt'),
      tipo: '1',
      eventos: [],
      codOdtAux: '',
      rules: {
        required: value => !!value || this.$t('lang.error.camposObligatorios'), 
      },
      opUid: this.$store.getters.getOpuid,
      opId: this.$store.getters.getIdTienda,
      evento: '',
      modeloTarifarioActual: '',
      modeloTarifarioPremium: '',
      eventoPremium: '',
      modelosTarifa: '',
      cargandoEventos: false,
      cargandoEventosPremium: false,
      nombreFicheroInforme: '',
      registroModelosTarifa: ''
    }
  },
  computed: {
    cambiotienda () {
      return this.$store.getters.getOpuid;
    },
    cambiotiendaId () {
      return this.$store.getters.getIdTienda;
    }
  },
  watch: {
    cambiotienda (value) {
      this.opUid = value;
      // this.init();
    },
    cambiotiendaId (value) {
      this.opId = value;
      this.init()
    },
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.getRegistroModelosTarifa()
      this.nombreFicheroInforme = this.getNombreFicheroInforme()
    },
    enviar() {
      sessionStorage.setItem('codOdt', this.codOdt)
      this.$refs.myForm.validate()
      if (this.formValid && this.modeloTarifarioPremium !=='') {
        if (this.tipo == '1' || (this.tipo == '2' && this.evento !=='' && this.eventoPremium !== '' && this.modeloTarifarioActual !== '')) {
          let params = {
            codOdt: this.codOdt,
            fila: this.fila,
            columna: this.columna,
            numetiq: this.numEtiquetas,
            tipo: this.tipo,
            modeloTarifa: this.modeloTarifarioActual,
            modeloTarifaPremium: this.modeloTarifarioPremium,
            idEventoActual: this.evento,
            idEventoPremium: this.eventoPremium,
            nombreFichero: this.nombreFicheroInforme
          }
          this.$parent.cargando = true
          informesApiService.getEtiquetas(params)
            .then((data) => {
              this.$parent.cargando = false
              const linkSource = `data:application/pdf;base64,${data}`;
              const downloadLink = document.createElement("a");
              const fileName = "etiquetas.pdf";

              downloadLink.href = linkSource;
              downloadLink.download = fileName;
              downloadLink.click()
            })
            .catch(error => {
              this.$parent.cargando = false
              this.$root.$emit('mostrarAlerta', error, 'error')
              console.log(error)
            })
        } else {
          this.$root.$emit('mostrarAlerta', 'Hay que seleccionar los eventos', 'error')
        }
      } else {
        this.$root.$emit('mostrarAlerta', 'Faltan datos por rellenar', 'error')
      }
    },
    getEventos() {
      this.cargandoEventos = true
      twisterRestApiService.getEventosTarifaTienda(this.modeloTarifarioActual, this.opUid, 'S') 
        .then((data) => {
          this.cargandoEventos = false
          this.eventos = data
        })
        .catch(error => {
          this.cargandoEventos = false
          this.$root.$emit('mostrarAlerta', 'Error eventos', 'error')
          console.log(error)
        })
    },
    getEventosPremium() {
      this.cargandoEventosPremium = true
      twisterRestApiService.getEventosPremium(this.modeloTarifarioPremium, 'S') 
      .then((data) => {
        this.cargandoEventosPremium = false
        this.eventosPremium = data
      })
      .catch(error => {
        this.cargandoEventosPremium = false
        this.$root.$emit('mostrarAlerta', 'Error eventos premium', 'error')
        console.log(error)
      })
    },
    getModelosTarifa() {
      twisterRestApiService.getModelosTarifa() 
        .then((data) => {
          this.modelosTarifa = data.filter(x => this.regModelosTarifa.split(',').some(y => y == x.id)) 
          if (this.modelosTarifa.length === 1) {
            this.modeloTarifarioActual = data[0]
            this.modeloTarifarioPremium = data[0]
          }
        })
        .catch(error => {
          this.$root.$emit('mostrarAlerta', 'Error modelos tarifas', 'error')
          console.log(error)
        })
    },
    getRegistroModelosTarifa() {
      registroApiService.getRegistroById('modelos_tarifa_seleccionados') 
        .then((data) => {
          if (data) {
            this.regModelosTarifa = data.regTxt
          } else {
            this.regModelosTarifa = ''
          }
          this.getModelosTarifa()
        })
        .catch(error => {
          this.$root.$emit('mostrarAlerta', 'Error registro', 'error')
          console.log(error)
        })
    }
  }
}
</script>